import { render } from "./cardsLoader.vue?vue&type=template&id=6f672d58"
import script from "./cardsLoader.vue?vue&type=script&lang=js"
export * from "./cardsLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__